export default __webpack_public_path__ + "static/media/ham.75344d30.svg";